"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Slide: function() {
        return _Slide.Slide;
    },
    SlideRelaxed: function() {
        return _Slide.SlideRelaxed;
    },
    SlideSnappy: function() {
        return _Slide.SlideSnappy;
    }
});
const _Slide = require("./Slide");
